import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../core/api';
import './Login.css';

export default function ChangePassword() {
  const navigate = useNavigate();
  const [f, setF] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (f.newPassword.length < 6) return setError('رمز جدید باید حداقل ۶ کاراکتر باشد');
    if (f.newPassword !== f.confirm) return setError('تکرار رمز جدید مطابقت ندارد');

    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        currentPassword: f.currentPassword,
        newPassword: f.newPassword,
      });
      const me = await api.get('/auth/me');
      localStorage.setItem('user', JSON.stringify(me.data.user || me.data));
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'خطا در تغییر رمز عبور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="logo-dot"><i className="fa-solid fa-key" /></div>
        <h1>تعیین رمز عبور جدید</h1>
        <p className="sub">برای ادامه، رمز موقت را با رمز دلخواه خود جایگزین کنید</p>
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label>رمز فعلی (رمز موقت)</label>
            <input type="password" value={f.currentPassword} onChange={set('currentPassword')} required />
          </div>
          <div className="field">
            <label>رمز جدید</label>
            <input type="password" value={f.newPassword} onChange={set('newPassword')} required />
          </div>
          <div className="field">
            <label>تکرار رمز جدید</label>
            <input type="password" value={f.confirm} onChange={set('confirm')} required />
          </div>
          <button className="btn" type="submit" disabled={loading}>
            {loading ? 'در حال ذخیره...' : 'ذخیره رمز جدید'}
          </button>
        </form>
      </div>
    </div>
  );
}